<div class="ui icon message message-container">
    <div class="content">
        <div class="blue header">Whose availability do you want to use?</div>
        <p>
            Since this is an <em>External On-Behalf</em> meeting, please select which invitee should be the first to
            receive the invite and share their availability. After this is done, the remaining invitees will be notified
            so they can select times based on the first invitee's availability.
            <a href="https://faq.calendarhero.com/hc/en-us/articles/4430392137499-Work-as-a-team-with-Shared-Availability-Collective-Round-Robin-On-Behalf-" target="_blank">Learn More</a>
        </p>
        <div class="ui segments on-behalf-invitee-list">
            <div class="ui segment" *ngFor="let contact of wizardService.selection">
                <div class="ui radio checkbox" (click)="onSelect(contact.id)">
                    <input
                        type="radio"
                        name="contact"
                        tabindex="0"
                        class="hidden"
                        [checked]="contact.id === selectedContactId"
                    />
                    <label>
                        <span class="label__title">{{ contact.name }}</span>
                        <span class="label__subtitle">
                            ({{ contact.defaultEmail || (contact.email && contact.email[0]) }})</span
                        >
                        <span *ngIf="contact.id === selectedContactId" class="label__is-selected"
                            >[ Use this invitee's availability ]</span
                        >
                    </label>
                </div>
            </div>
        </div>
    </div>
    <img class="ui medium image" src="/assets/images/time-selection.svg" />
</div>
